import React from 'react'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import MenuBookIcon from '@mui/icons-material/MenuBook'

import { BookListStyle } from '../styles'
import BookModal from '../modals/BookModal'
import ResourceDescription from '../shared/ResourceDescription'
import ResourceList from './ResourceList'
import { openExternal } from '../../utils/safeUrl'

const BookList = (props) => {
    const openResource = () => {
        openExternal(props.link)
        return false;
    }

    const secondary = (
        <>
            <Box sx={BookListStyle.secondary}>
                <Typography variant='p'>
                    <span style={{"fontWeight":"bold"}}>By:</span> {props.authors}
                </Typography>
            </Box>
            <ResourceDescription
                description={props.description}
                containerSx={BookListStyle.titleContainer}
                typographyProps={{ ...BookListStyle.description, gutterBottom: true }}
            />
            <Box sx={BookListStyle.secondary}>
                <Typography variant='p'>
                    <span style={{"fontWeight":"bold"}}>Genre:</span> {props.book_type_name}
                </Typography>
            </Box>
            <Box sx={BookListStyle.secondary}>
                <Typography variant='p'>
                    <span style={{"fontWeight":"bold"}}>ISBN:</span> {props.isbn}
                </Typography>
            </Box>
        </>
    )

    return (
        <ResourceList
            Icon={MenuBookIcon}
            listStyle={BookListStyle}
            modal={<BookModal {...props} />}
            title={props.title}
            date={props.pub_date}
            content_tags={props.content_tags}
            medical_specialty_tags={props.medical_specialty_tags}
            is_seminal_work={props.is_seminal_work || props.seminal_work}
            onOpen={openResource}
            secondaryContent={secondary}
        />
    )
}

export default BookList
